import { render, staticRenderFns } from "./recruitment.vue?vue&type=template&id=99d6d57e&scoped=true&"
import script from "./recruitment.vue?vue&type=script&lang=js&"
export * from "./recruitment.vue?vue&type=script&lang=js&"
import style0 from "./recruitment.vue?vue&type=style&index=0&id=99d6d57e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d6d57e",
  null
  
)

component.options.__file = "recruitment.vue"
export default component.exports